module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("buPWC"))).then(() => module.bundle.root('1iHdE'));